import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { Navbar, NavbarGroup } from '@blueprintjs/core';
import '../project-billing/PBNavBar.scss';
// import 'src/styles/components/_subNavBar.scss';

const PBNavBar: React.FC = () => {
    type page = 'approval' | 'officeexpenses' | 'timeexpensechecklist' | 'nonrecon' | 'timeexpense' | 'invoice' | 'costbreakdown';

    const dispatch = useDispatch();
    const [currentSection, setCurrentSection] = useState<page>(undefined);

    useEffect(() => {
        if (window.location.pathname.indexOf('/officeexpenses') >= 0) {
            setCurrentSection('officeexpenses');
        } else if (window.location.pathname.indexOf('/approval') >= 0) {
            setCurrentSection('approval');
        } else if (window.location.pathname.indexOf('/timeexpensechecklist') >= 0) {
            setCurrentSection('timeexpensechecklist');
        } else if (window.location.pathname.indexOf('/nonrecon') >= 0) {
            setCurrentSection('nonrecon');
        } else if (window.location.pathname.indexOf('/timeexpense') >= 0) {
            setCurrentSection('timeexpense');
        } else if (window.location.pathname.indexOf('/invoice') >= 0) {
            setCurrentSection('invoice');
        } else if (window.location.pathname.indexOf('/costbreakdown') >= 0) {
            setCurrentSection('costbreakdown');
        }
    });

    const navigate = (path: string) => {
        console.log(currentSection);
        if (window.location.pathname.includes('project-billing/') && currentSection) {
            let newPath = path.replace('project-billing/', '');
            dispatch(push(newPath));
        } else {
            dispatch(push(path));
        }
    };

    const isActive = (section: string) => {
        if (section === currentSection) {
            return 'active';
        }
        return '';
    };

    return (
        <Navbar className="pb-nav-bar">
            <NavbarGroup>
                <div className={'pb-sub-nav-menu-item ' + isActive('approval')} onClick={() => navigate('project-billing/approval')}>
                    Project Billing Approval
                </div>
                <div className={'pb-sub-nav-menu-item ' + isActive('officeexpenses')} onClick={() => navigate('project-billing/officeexpenses')}>
                    Office Expenses
                </div>
                <div className={'pb-sub-nav-menu-item ' + isActive('timeexpensechecklist')} onClick={() => navigate('project-billing/timeexpensechecklist')}>
                    Time & Expense Checklist
                </div>
                <div className={'pb-sub-nav-menu-item ' + isActive('nonrecon')} onClick={() => navigate('project-billing/nonrecon')}>
                    Non-Reconciled
                </div>
                <div className={'pb-sub-nav-menu-item ' + isActive('timeexpense')} onClick={() => navigate('project-billing/timeexpense')}>
                    Time & Expense
                </div>
                <div className={'pb-sub-nav-menu-item ' + isActive('invoicemaster')} onClick={() => navigate('project-billing/invoice')}>
                    Invoices
                </div>
                <div className={'pb-sub-nav-menu-item ' + isActive('costbreakdown')} onClick={() => navigate('project-billing/costbreakdown')}>
                    Cost Breakdown
                </div>
            </NavbarGroup>
        </Navbar>
    );
};

export default PBNavBar;



// WEBPACK FOOTER //
// ./src/components/project-billing/PBNavBar.tsx